/**
 * EcoFeed — displays the last eco messages for a circle.
 * Props:
 *   echos  {array}  list of echo objects from /api/circles/{id}/echos
 *   loading {bool}
 */

import { formatDistanceToNow, parseISO } from "date-fns";
import { ptBR } from "date-fns/locale";

const ECHO_ICONS = {
  advance: "💧",
  watering: "🪣",
  fertilizer_between_circles: "🌿",
};

const ECHO_BG = {
  advance: "bg-blue-50 border-blue-100",
  watering: "bg-purple-50 border-purple-100",
  fertilizer_between_circles: "bg-green-50 border-green-100",
};

function relativeTime(isoStr) {
  try {
    return formatDistanceToNow(parseISO(isoStr), { addSuffix: true, locale: ptBR });
  } catch {
    return "";
  }
}

export default function EcoFeed({ echos = [], loading = false }) {
  if (loading) {
    return (
      <div className="space-y-2">
        {[1, 2, 3].map((i) => (
          <div key={i} className="h-12 rounded-xl bg-gray-100 animate-pulse" />
        ))}
      </div>
    );
  }

  if (!echos.length) {
    return (
      <div className="text-center py-6 text-gray-400 text-sm">
        <p className="text-2xl mb-1">🌱</p>
        <p>Os ecos do círculo aparecerão aqui</p>
      </div>
    );
  }

  return (
    <div className="space-y-2">
      {echos.map((echo) => (
        <EchoItem key={echo.echo_id} echo={echo} />
      ))}
    </div>
  );
}

function EchoItem({ echo }) {
  const icon = ECHO_ICONS[echo.echo_type] || "🌿";
  const bg = ECHO_BG[echo.echo_type] || "bg-gray-50 border-gray-100";
  const time = relativeTime(echo.sent_at);

  return (
    <div className={`flex items-start gap-3 rounded-xl border px-3 py-2.5 ${bg}`}>
      <span className="text-xl leading-none mt-0.5">{icon}</span>
      <div className="flex-1 min-w-0">
        <p className="text-sm text-gray-800 leading-snug">{echo.message_text}</p>
        {time && <p className="text-xs text-gray-400 mt-0.5">{time}</p>}
      </div>
    </div>
  );
}
